import isArray from "lodash/isArray";
import { stringify } from "qs";

export function stringifyQs(params: {}): string {
  return stringify(params, {
    arrayFormat: "indices"
  });
}

export function getArrayQueryParam(param: string | string[]): string[] {
  if (!param) {
    return undefined;
  }

  if (isArray(param)) {
    return param;
  }

  return [param];
}

export function buildUrl(path: string, params: Record<string, any>): string {
  const query = stringifyQs(params);
  return query ? `${path}?${query}` : path;
}
